import React, { Component } from 'react';
import PropTypes from 'prop-types';
import enhanceWithClickOutside from 'react-click-outside';

import Wrapper from './Wrapper';
import SearchBar from './SearchBar';
import SearchButton from './SearchButton';

// The "...rest" of the props is lengthy, and there is no need to individually specify them here.
export class Search extends Component {
  handleClickOutside = (e) => {
    this.props.onOutsideClick(e);
  };

  render() {
    const {
      expanded,
      performSearch,
      toggleSearchExpanded,
      searchValue,
      ...rest
    } = this.props;

    return (
      <Wrapper>
        <SearchBar
          expanded={expanded}
          performSearch={performSearch}
          searchValue={searchValue}
          {...rest}
        />
        <SearchButton
          expanded={expanded}
          onClick={toggleSearchExpanded}
          performSearch={performSearch}
          searchValue={searchValue}
        />
      </Wrapper>
    );
  }
}

Search.propTypes = {
  expanded: PropTypes.bool.isRequired,
  performSearch: PropTypes.func.isRequired,
  searchValue: PropTypes.string.isRequired,
  toggleSearchExpanded: PropTypes.func.isRequired,
  onOutsideClick: PropTypes.func.isRequired,
};

export default enhanceWithClickOutside(Search);



// WEBPACK FOOTER //
// ./components/Search/index.js